import {ActivityType} from '../../../../../../backend/interfaces/activity-type';
import {EntityActivitiesRepository} from '../../../../../../repositories/entity-activities';
import {MEALS_GROUP_ID, MEALS_SECTOR_ID} from '../../../../../constants';

/**
 * @example
 * ```
 * "Refeicao Principal" => "RP"
 * "Lanche da tarde" => "LT"
 * "Ceia" => "Ce"
 * ```
 */
export function abbreviateMealName(name: string): string {
  const words = name.trim().split(/[\s-]+/);
  if (words.length === 1) {
    return words[0].substring(0, 2);
  }
  const first = words[0][0];
  const last = words[words.length - 1][0];
  return `${first}${last}`.toUpperCase();
}

export async function getMealsActivityTypes(entityId: string): Promise<ActivityType[]> {
  const meals = await EntityActivitiesRepository.instance.getAllTypes(
    entityId,
    MEALS_SECTOR_ID,
    MEALS_GROUP_ID
  );

  if (!meals || meals.length === 0) return [];

  // hack: jejum is last so we move to 1st position.
  const jejum = meals.at(-1);
  const others = meals.slice(0, -1);

  return jejum ? [jejum, ...others] : others;
}
